export const BREEDS = [
  {
    id: 0,
    name: 'NOVOgen White Light',
  },
  {
    id: 1,
    name: 'NOVOgen White Classic',
  },
  {
    id: 2,
    name: 'NOVOgen Brown Light',
  },
  {
    id: 3,
    name: 'NOVOgen Brown Classic',
  },
  {
    id: 4,
    name: 'LSL Classic',
  },
  {
    id: 5,
    name: 'LSL lite',
  },
  {
    id: 6,
    name: 'Lohmann Brown Classic',
  },
  {
    id: 7,
    name: 'Lohmann Brown Lite',
  },
  {
    id: 8,
    name: 'H&N Nick Chick',
  },
  {
    id: 9,
    name: 'H&N Super Nick',
  },
  {
    id: 10,
    name: 'H&N Brown Nick',
  },
  {
    id: 11,
    name: 'Hy-line W36',
  },
  {
    id: 12,
    name: 'Hy-line Brown',
  },
  {
    id: 13,
    name: 'Dekalb White',
  },
  {
    id: 14,
    name: 'Isa Brown',
  },
  {
    id: 15,
    name: 'Bovans Brown',
  },
  {
    id: 16,
    name: 'Bovans White',
  },

  // Removed Lohmann LSL White Classic, whouls be LSL Classic
  // {
  //   id: 17,
  //   name: 'Lohmann LSL White Classic',
  // },
  //
  // These should not be able to be selected, since they are legacy breeds.
  // {
  //   id: 18,
  //   name: 'Dekalb Amber',
  // },
  // {
  //   id: 19,
  //   name: 'Isa Warren Plein Air',
  // },
  // {
  //   id: 20,
  //   name: 'Hyline Silver Brown',
  // },
  // {
  //   id: 21,
  //   name: 'Lohmann LSL White Lite',
  // },
  // {
  //   id: 22,
  //   name: 'Hyline Brown',
  // },
  // {
  //   id: 23,
  //   name: 'Bovans Goldline',
  // },
  {
    id: 24,
    name: 'H&N Crystal Nick',
  },
  {
    id: 25,
    name: 'Warren Brown',
  },
  {
    id: 26,
    name: 'Warren White',
  },
  {
    id: 27,
    name: 'Dekalb White 2025',
  },
];
